import { render, staticRenderFns } from "./PaymentRequirementBusiness.vue?vue&type=template&id=48b66579&scoped=true&"
import script from "./PaymentRequirementBusiness.vue?vue&type=script&lang=js&"
export * from "./PaymentRequirementBusiness.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRequirementBusiness.vue?vue&type=style&index=0&id=48b66579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b66579",
  null
  
)

export default component.exports